<template>
  <!-- _________________________ RESET PASSWORD _________________________ -->
  <div id="login-div">

    <b-alert :show="ui.showError" class="mt-4" variant="danger">
      {{ ui.showErrorMessage }}
    </b-alert>
    <b-alert :show="ui.showSuccess" class="mt-5" variant="success">
      {{ $t('ChangePassword.success') }}
      <br/>
    </b-alert>
    <div v-show="ui.showSuccess" class="mt-4">
      <b-button
        :class="{ 'loading-ellipsis': isLoading }"
        :disabled="isLoading"
        class="btn-block"
        type="submit"
        variant="secondary">
        {{ this.$t('Connecting') }}
      </b-button>
    </div>


    <div v-if="!ui.showError && !ui.showSuccess">
        <div class="d-flex align-items-center mb-2 page-title" @click="backToLogin()">
          <h1 class="page-title"> {{ $t('ChangePassword.newPassword') }}</h1>
        </div>
      <div class="mt-3">
        <p v-html="$t('ChangePassword.info', {mail: email})"></p>
      </div>

      <form ref="form" class="mt-4" @submit.stop.prevent="handleSubmit">
        <!-- New password -->
        <b-form-group
          :label="$t('loginSecondCredential')"
          label-for="password-input">
          <b-input-group>
            <b-form-input
              ref="password"
              id="password-input"
              class="form-input-with-right-append-inside"
              v-model="form.newPassword.value"
              :type="showPassword ? 'text' : 'password'"
              autocomplete="off"
              required>
            </b-form-input>
            <b-input-group-append>
              <div class="cursor-pointer custom-eye" @click.prevent="togglePassword">
                <i v-if="!showPassword" class="ph-custom ph-eye-fill"/>
                <i v-else class="ph-custom ph-eye-slash-fill"/>
              </div>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

        <div class="mt-4">
          <b-button
            :class="{ 'loading-ellipsis': isLoading }"
            :disabled="isLoading"
            class="btn-block"
            type="submit"
            variant="primary">
            {{ isLoading ? $t('Connecting') + '...' : $t('Validate') }}
          </b-button>

        </div>

      </form>
    </div>

  </div>
</template>

<script>

import api from '../../../services/api'

export default {

  name: 'ResetPasswordComponent',

  data () {
    return {
      isLoading: false,
      token: this.$route.params.token,
      userId: this.$route.params.userId,
      form: {
        newPassword: {
          value: null,
          state: null,
          invalidFeedback: null
        },
      },
      ui: {
        showSuccess: false,
        showError: false,
        showErrorMessage: ''
      },
      email: null,
      showPassword: false,
    }
  },

  emits: ['showLoginView', 'tokenExpired'],

  watch: {
    'ui.showErrorMessage': {
      immediate: true,
      handler(value) {
        if (value) {
          this.$emit('tokenExpired', true)
        }
      }
    }
  },
  mounted() {
    this.checkToken()
  },

  methods: {

    togglePassword () {
      this.showPassword = !this.showPassword
    },

    checkToken() {
      let data = new FormData()
      data.append('token', this.token)
      data.append('userId', this.userId)

      api({
        method: 'POST',
        url: `/forgotPassword/checkResetPasswordToken`,
        data: data
      })
        .then((response) => {
          this.email = response.data.email

        })
        .catch((error) => {
          if (!error.response) {
            console.log("error", error)
          }
          if (error.response && error.response.status === 401) {
            this.ui.showErrorMessage = this.$i18n.t('Login.error');
            this.ui.showError = true;
          }
          if (error.response && error.response.status === 403) {
            this.ui.showErrorMessage = this.$i18n.t(error.response.data.message);
            this.ui.showError = true;
          }
        })

    },

    handleSubmit() {
      if (!this.isFormValid()) {
        return
      }
      this.isLoading = true

      let formData = new FormData()
      formData.append('token', this.token)
      formData.append('userId', this.userId)
      formData.append('newPassword', this.form.newPassword.value)

      api({
        method: 'POST',
        url: `/forgotPassword/resetPassword`,
        data: formData
      })
        .then(() => {
          this.ui.showSuccess = true
          this.ui.showError = false
          setTimeout(() => {
            this.isLoading = false;
            this.autoLogin()
          }, 3000);
        })
        .catch((error) => {
          if (!error.response) {
            console.log("error", error)
          }
          if (error.response && error.response.status === 401) {
            this.ui.showErrorMessage = this.$i18n.t('Login.error')
            this.ui.showError = true
          }
          if (error.response && error.response.status === 403) {
            this.ui.showErrorMessage = this.$i18n.t(error.response.data.message)
            this.ui.showError = true
          }
        })
    },

    isFormValid() {
      let valid = this.$refs.form.checkValidity()
      if (!valid) {
        this.$refs.form.reportValidity()
        return false
      }
      if (this.form.newPassword.value == null || this.form.newPassword.value.trim() === '') {
        this.form.newPassword.state = false
        this.form.newPassword.invalidFeedback = this.$i18n.t('MandatoryField')
        return false
      } else if (this.form.newPassword.value.trim().length < 8) {
        this.form.newPassword.state = false
        this.form.newPassword.invalidFeedback = this.$i18n.t('Password.minlenght.error')
        return false
      }
      return true
    },

    async autoLogin() {
      let data = {
        username: this.email.trim(),
        password: this.form.newPassword.value.trim()
      }
      let formData = new FormData()
      formData.append('isForIndividual', "true")
      formData.append('username', data['username'])
      formData.append('password', data['password'])

      await api({
        method: 'POST',
        url: '/authentication/beforeLogin',
        data: formData
      })
        .then(async (response) => {
          // login
          await this.$store.dispatch('LogIn', data)
            .then(async () => {
              this.ui.showError = false
              this.goToHome()
            })
            .catch((error) => {
              if (error.toString() === 'Locked') {
                this.ui.showErrorMessage = this.$i18n.t('Profile.forbidden.error')
                this.ui.showError = true
              }
            })
        })
        .catch((error) => {
          if (!error.response) {
            console.log("error", error)
          }

          if (error.response && error.response.status === 401) {
            this.ui.showErrorMessage = this.$i18n.t('Login.error')
            this.ui.showError = true
          }
          if (error.response && error.response.status === 403) {
            this.ui.showErrorMessage = this.$i18n.t(error.response.data.message)
            this.ui.showError = true
            if (error.response.data.message === 'account.not.validated.error') {
              this.ui.showValidateAccountError = true
            }
          }
          if (error.response && error.response.status === 423) {
            this.ui.showErrorMessage = this.$i18n.t('account.locked.error')
            this.ui.showError = true
          }

          //ces 2 cas ne devraient jamais arriver car seuls les particuliers ont accès au resetPassword du GP
          if (error.response && error.response.status === 468) {
            //PRO
            this.ui.showErrorMessage = this.$i18n.t('Login.error.connect.on.pro')
            this.ui.showError = true
          }
          if (error.response && error.response.status === 467) {
            //OTHERS
            this.ui.showErrorMessage = this.$i18n.t('Login.error')
            this.ui.showError = true
          }

          if (error.response && error.response.status === 500) {
            this.ui.showErrorMessage = this.$i18n.t('internal.server.error')
            this.ui.showError = true
          }
        })
    },


    backToLogin() {
      this.$emit('showLoginView')
    },

    goToHome() {
      this.$router.push({
        name: 'Home'
      })
    }

  }

}

</script>

<style scoped>
.chevron-color {
  color: var(--main-yellow-medium)
}

@keyframes ellipsis {
  to {
    content: "\2026"; /* trois points */
  }
}

.loading-ellipsis:after {
  content: ".";
  animation: ellipsis 1s steps(3, end) infinite;
}

.header-button {
  background-color: var(--main-yellow-medium);
  border-radius: 10px;
  height: 32px;
  width: 32px;
  min-width: 36px;
  margin-right: 1em;
  display: flex;
  justify-content: center;
  align-items: center;
  color : var(--main-black-medium)
}

.header-button:hover {
  cursor: pointer;
  background-color: var(--main-yellow-dark);
}

.custom-eye{
  border: 1px solid var(--main-grey-dark) !important;
  border-left: none;
  border-top-right-radius: var(--form-control-border-radius);
  border-bottom-right-radius: var(--form-control-border-radius);
  padding-left: 1em;
  padding-right: 1em;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--main-grey-medium) !important;
  background-color: var(--main-black-medium) !important;
}

</style>



// WEBPACK FOOTER //
// src/views/auth/components/ResetPasswordComponent.vue